import $http from '../../shared/http';

export const service_activities_templates = {
  namespaced: true,
  state: () => {
    return {
      serviceActivitiesTemplateCreated: false,
      serviceActivitiesTemplateRegisterData: null,
      currentServiceActivitiesTemplate: null,
      serviceActivitiesTemplateEdited: false,
      serviceActivitiesTemplatesForSelect: null,
      isServiceActivitiesTemplateDownloaded: false,
      serviceActivitiesTemplateEditData: null,
      serviceActivitiesTemplateUsed: null,
      serviceActivitiesTemplateDisabled: null,
      serviceActivitiesTemplatesExist: false,
    };
  },
  getters: {
    getServiceActivitiesTemplatesForSelect: (state) => state.serviceActivitiesTemplatesForSelect,
    getServiceActivitiesTemplateRegisterData: (state) =>
      state.serviceActivitiesTemplateRegisterData,
    getServiceActivitiesTemplateCreated: (state) => state.serviceActivitiesTemplateCreated,
    isServiceActivitiesTemplateEdited: (state) => state.serviceactivitiestemplateEdited,
    getCurrentServiceActivitiesTemplate: (state) => state.currentServiceActivitiesTemplate,
    getCurrentServiceActivitiesTemplateID: (state) =>
      state.currentServiceActivitiesTemplate ? state.currentServiceActivitiesTemplate.id : null,
    getServiceActivitiesTemplateDownloaded: (state) => state.isServiceActivitiesTemplateDownloaded,
    getServiceActivitiesTemplateUsed: (state) => state.serviceActivitiesTemplateUsed,
    getServiceActivitiesTemplateDisabled: (state) => state.serviceActivitiesTemplateDisabled,
    serviceActivitiesTemplatesExist: (state) => state.serviceActivitiesTemplatesExist,
  },
  mutations: {
    setServiceActivitiesTemplatesForSelect: (state, payload) =>
      (state.serviceActivitiesTemplatesForSelect = payload),
    initServiceActivitiesTemplateForm: (state) => {
      state.serviceActivitiesTemplatesForSelect = null;
    },
    setServiceActivitiesTemplateCreated: (state, payload) =>
      (state.serviceActivitiesTemplateCreated = payload),
    setServiceActivitiesTemplateEdited: (state, payload) =>
      (state.serviceActivitiesTemplateEdited = payload),
    setNewServiceActivitiesTemplateID: (state, payload) =>
      (state.newServiceActivitiesTemplateID = payload),
    setEditServiceActivitiesTemplateID: (state, payload) =>
      (state.editServiceActivitiesTemplateID = payload),
    setServiceActivitiesTemplateRegisterData: (state, payload) =>
      (state.serviceActivitiesTemplateRegisterData = payload),
    setServiceActivitiesTemplateEditData: (state, payload) =>
      (state.serviceActivitiesTemplateEditData = payload),
    setCurrentServiceActivitiesTemplate: (state, data) => {
      state.currentServiceActivitiesTemplate = data;
    },
    setServiceActivitiesTemplateDownloaded: (state, payload) => {
      state.isServiceActivitiesTemplateDownloaded = payload;
    },
    setServiceActivitiesTemplateUsed: (state, payload) => {
      state.serviceActivitiesTemplateUsed = payload;
    },
    setServiceActivitiesTemplateDisabled: (state, payload) => {
      state.serviceActivitiesTemplateDisabled = payload;
    },
    setServiceActivitiesTemplatesExist: (state, payload) => {
      if (!payload) {
        state.serviceActivitiesTemplatesExist = false;
      }
      state.serviceActivitiesTemplatesExist = payload > 0 ? true : false;
    },
  },
  actions: {
    async loadServiceActivitiesTemplatesForSelect({ commit }, { churchId }) {
      return $http('v2')
        .get(`organisations/${churchId}/service_activities_templates/select`, {
          canBeImpersonated: true,
        })
        .then((response) => {
          commit('setServiceActivitiesTemplatesForSelect', response.data.data);
          return response;
        });
    },

    async createServiceActivitiesTemplateAction({ commit, getters }) {
      return new Promise(async (resolve, reject) => {
        commit('setServiceActivitiesTemplateCreated', false);
        return await $http()
          .post(
            '/service-activities-templates',
            getters['getServiceActivitiesTemplateRegisterData'],
            { headers: { 'X-Is-Notifiable': 'On' } }
          )
          .then(async (response) => {
            commit('setServiceActivitiesTemplateCreated', true);
            return resolve(response);
          })
          .catch((error) => {
            commit('setServiceActivitiesTemplateCreated', false);
            reject(error);
          });
      });
    },
    async updateServiceActivitiesTemplateAction({ commit, getters }, service_id) {
      return new Promise(async (resolve, reject) => {
        commit('setServiceActivitiesTemplateCreated', false);
        return await $http()
          .patch(
            `/service-activities-templates/${service_id}`,
            getters['getServiceActivitiesTemplateRegisterData'],
            {
              headers: { 'X-Is-Notifiable': 'On' },
            }
          )
          .then(async (response) => {
            return resolve(response);
          })
          .catch((error) => {
            commit('setServiceActivitiesTemplateCreated', false);
            reject(error);
          });
      });
    },

    async DELETE_SERVICE_ACTIVITIES_TEMPLATE(ctx, { id }) {
      return $http()
        .delete(`/service-activities-templates/${id}`, { notifiable: true })
        .then((response) => {
          return response;
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },

    async loadCurrentServiceActivitiesTemplate({ commit }, { id, mode }) {
      commit('setCurrentServiceActivitiesTemplate', null);
      commit('setServiceActivitiesTemplateDownloaded', false);
      return new Promise(async (resolve, reject) => {
        await $http()
          .get(`/service-activities-templates/${id}`, { params: { mode: mode ? mode : null } })
          .then((response) => {
            commit('setServiceActivitiesTemplateDownloaded', true);
            commit('setCurrentServiceActivitiesTemplate', response.data.data);
            return resolve(response);
          })
          .catch((error) => {
            return reject(error);
          });
      });
    },
    async isServiceActivityTemplateUsed({ commit }, template_id) {
      return new Promise(async (resolve, reject) => {
        commit('setServiceActivitiesTemplateUsed', null);
        return await $http()
          .get(`/service-activities-templates/${template_id}/usage`)
          .then(async (response) => {
            commit('setServiceActivitiesTemplateUsed', response.data.data);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    async disableTemplateAction({ commit }, { template_id, form }) {
      commit('setServiceActivitiesTemplateDisabled', null);
      return new Promise(async (resolve, reject) => {
        await $http()
          .patch(`/service-activities-templates/${template_id}/status`, form, {
            headers: { 'X-Is-Notifiable': 'On' },
          })
          .then(async (response) => {
            commit('setServiceActivitiesTemplateDisabled', response.data.data);
            return resolve(response);
          })
          .catch((error) => {
            commit('setServiceActivitiesTemplateDisabled', false);
            return reject(error);
          });
      });
    },

    checkServiceActivitiesTemplatesExistenceAction({ commit }, { churchId }) {
      return new Promise(async (resolve, reject) => {
        await $http()
          .get(`/organisations/${churchId}/service-activities-templates/check/existence`, {
            canBeImpersonated: true,
          })
          .then(async (response) => {
            commit('setServiceActivitiesTemplatesExist', response.data.data);
            resolve(response);
          })
          .catch((error) => {
            commit('setServiceActivitiesTemplatesExist', null);
            reject(error);
          });
      });
    },
  },
};
